'use strict';

class Modal {
    constructor(modal) {
        this.modal = modal;
        this.id = this.modal.id;
        this.header = document.querySelector('.header');
        this.modalBody = this.modal.querySelector('.modal__body');
        this.openers = document.querySelectorAll('.js-modal-open[data-modal-id="' + this.id + '"]');
        this.closers = this.modal.querySelectorAll('.js-modal-close');
        this.modalBg = (document.querySelector('.modal-bg')) ? document.querySelector('.modal-bg') : '';
        this.form = this.modal.querySelector('.form');

        this.populate();
        this.watch();
    }

    watch() {
        if (this.modalBg) {
            this.modalBg.addEventListener('click', event => {
                this.close(event);
            });
        }

        if (this.openers) {
            var root = this;

            for (let a = 0; a < this.openers.length; a += 1) {
                this.openers[a].addEventListener('click', event => {
                    event.preventDefault();

                    let content = this.openers[a].getAttribute('data-modal-content');
                    if (content) {
                        this.populate(content);
                    }

                    if (this.openers[a].classList.contains('js-modal-close')) {
                        // Wait for close animation, otherwise we won't have a background
                        setTimeout(function() {
                            root.open();
                        }, 400);
                    } else {
                        root.open();
                    }
                })
            }
        }

        if (this.closers) {
            for (let b = 0; b < this.closers.length; b += 1) {
                this.closers[b].addEventListener('click', event => {
                    this.close(event);
                });
            }
        }
    }

    populate(content) {
        // Loop over each key/value pair in json data
        if (content) {
            this.data = JSON.parse(content);
            
            Object.entries(this.data).forEach(([key, value]) => {
                // Get corresponding field in modal
                let fields = this.modal.querySelectorAll(`.js-modal-${key}`);

                // Fill field with data value
                for (let a = 0; a < fields.length; a += 1) {
                    if (typeof value === "object") {
                        for (let b = 0; b < value.length; b += 1) {
                            let template = fields[a].parentNode.appendChild(fields[a].cloneNode(true));

                            Object.entries(value[b]).forEach(([subkey, subvalue]) => {
                                let subfield = template.querySelector(`.js-modal-${subkey}`);

                                if (subfield.tagName === 'INPUT') {
                                    subfield.value = subvalue;
                                } else {
                                    subfield.innerHTML = subvalue;
                                }
                            });
                        }

                        fields[a].style.display = "none";
                    } else if (fields[a].tagName === 'INPUT') {
                        fields[a].value = value;
                    } else {
                        fields[a].innerHTML = value;
                    }
                }
            });
        }
    }

    open() {
        let tl = new TimelineLite();
        
        // Defaults
        tl.timeScale(3);
        TweenLite.defaultEase = Quart.easeOut;

        // Set top of modal to current scroll position
        if (document.documentElement.scrollTop > this.header.offsetHeight) {
            this.modal.style.top = (document.documentElement.scrollTop - document.querySelector('header').offsetHeight) + 'px';
        } else {
            this.modal.style.top = '0px';
        }

        // Create modal background
        if (document.querySelector('.modal-bg')) {
            this.modalBg = document.querySelector('.modal-bg');
        } else {
            this.modalBg = document.body.appendChild(document.createElement('div'));
            this.modalBg.classList.add('modal-bg');
        }

        this.modalBg.addEventListener('click', event => {
            this.close(event);
        });

        // Animate
        tl.set(this.modal, {display: 'block', x: '-50%', y: '100px'})
              .set(this.modalBg, {display: 'block'})
              .to(this.modal, 1, {autoAlpha: 1, y: '0px'})
              .to(this.modalBg, 1, {autoAlpha: 1, onComplete: this.showContent()}, '-=.8');
    }

    close(event) {
        event.preventDefault();

        let tl = new TimelineLite();

        const destroyModalBg = () => {
            this.modalBg.remove();
        }

        tl.timeScale(3);
        TweenLite.defaultEase = Quart.easeOut;
        
        tl.to(this.modalBody, 1, {autoAlpha: 0})
              .to(this.modalBg, 1, {autoAlpha: 0}, '-=1')
              .to(this.modal, 1, {autoAlpha: 0, y: '50px'}, '-=1')
              .set(this.modalBg, {display: 'none'})
              .set(this.modal, {display: 'none', onComplete: destroyModalBg});
    }

    showContent() {
        if (!this.modalBody) return;

        let tl = new TimelineLite();

        tl.to(this.modalBody, .3, {autoAlpha: 1});
    }

    static switchOverflow(modal, enableModalScroll) {
        if (enableModalScroll) {
            modal.style.overflowY = 'scroll';
            document.body.style.overflowY = 'hidden';
        } else {
            modal.style.overflowY = 'hidden';
            document.body.style.overflowY = 'auto';
        }
    }
}

function fInitModals() {
    const aModals = document.querySelectorAll('.modal');
    const sHash = location.hash;

    for (let i = 0; i < aModals.length; i += 1) {
        let modal = new Modal(aModals[i]);
        let modalHash = aModals[i].getAttribute('data-modal-hash');

        if (modalHash && sHash === '#' + modalHash) {
            modal.open();

            location.hash = '';
        }
    }
}